import { render, staticRenderFns } from "./registerNatura.vue?vue&type=template&id=576e6e82"
import script from "./registerNatura.vue?vue&type=script&lang=js"
export * from "./registerNatura.vue?vue&type=script&lang=js"
import style0 from "./registerNatura.vue?vue&type=style&index=0&id=576e6e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports